let openPanel = null;

export function closeAllPanelsExcept(component = null) {
    document.querySelectorAll('app-input').forEach(inst => {
        try {
            if (inst === component) return;
            if (inst.panel)   inst.panel.hidden = true;
            if (inst.trigger) inst.trigger.classList.remove('open');
            inst.isOpen = false;
        } catch (_) {}
    });
    openPanel = component;
}

export function closeOpenPanel() {
    if (!openPanel) return;
    openPanel.isOpen = false;
    openPanel.style.zIndex = '';
    if (openPanel.panel)   openPanel.panel.hidden = true;
    if (openPanel.trigger) openPanel.trigger.classList.remove('open');
    openPanel = null;
}

export function setOpenPanel(component) {
    if (openPanel && openPanel !== component) closeOpenPanel();
    openPanel = component;
}

export function clearOpenPanelRef(component) {
    if (openPanel === component) openPanel = null;
}

export function getOpenPanel() {
    return openPanel;
}

if (typeof window !== 'undefined') {
    window.addEventListener('resize', () => closeAllPanelsExcept(null));
    window.addEventListener('scroll', () => closeAllPanelsExcept(null));
}
